<template>
  <div class='tag-container'>
    <!-- <span>TAGS</span> -->
    <dsTagItem v-for='item in tags'
               :item="item"
               :language="language"></dsTagItem>
  </div>
</template>

<script>
import dsTagItem from './dsTagItem'
export default {
  name: 'dsTags',
  components: {
    dsTagItem
  },
  props: ['language', 'tags']
}
</script>

<style lang='scss' scoped>
@import '../styles/helpers/_mixins.scss';
@import '../styles/responsive/_manager.scss';
@import '../styles/_variables.scss';
@import '../styles/_space.scss';
@import '../styles/_color.scss';
@import '../styles/_typography.scss';

.tag-container {
  columns: 150px 2;
  overflow: hidden;
  padding-top: $baseline;
  span {
    font-style: italic;
    font-weight: bold;
    color: $secondary-color;
  }
  @include screen-size ('medium') {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// dsTags.vue?b0c49f32